/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import {
  ListRemoteSessionClientsResult,
  ListRemoteSessionClientsResult$inboundSchema,
} from "../components/listremotesessionclientsresult.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListGlobalRemoteSessionClientsSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ListGlobalRemoteSessionClientsRequest = {
  /**
   * The global remote_session_issuer id to list clients for.
   */
  remoteSessionIssuerId: string;
  /**
   * Pagination cursor.
   */
  cursor?: string | undefined;
  /**
   * Page size (default 50, max 100).
   */
  limit?: number | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

export type ListGlobalRemoteSessionClientsResponse = {
  result: ListRemoteSessionClientsResult;
};

/** @internal */
export type ListGlobalRemoteSessionClientsSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListGlobalRemoteSessionClientsSecurity$outboundSchema:
  z.ZodMiniType<
    ListGlobalRemoteSessionClientsSecurity$Outbound,
    ListGlobalRemoteSessionClientsSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function listGlobalRemoteSessionClientsSecurityToJSON(
  listGlobalRemoteSessionClientsSecurity:
    ListGlobalRemoteSessionClientsSecurity,
): string {
  return JSON.stringify(
    ListGlobalRemoteSessionClientsSecurity$outboundSchema.parse(
      listGlobalRemoteSessionClientsSecurity,
    ),
  );
}

/** @internal */
export type ListGlobalRemoteSessionClientsRequest$Outbound = {
  remote_session_issuer_id: string;
  cursor?: string | undefined;
  limit?: number | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListGlobalRemoteSessionClientsRequest$outboundSchema:
  z.ZodMiniType<
    ListGlobalRemoteSessionClientsRequest$Outbound,
    ListGlobalRemoteSessionClientsRequest
  > = z.pipe(
    z.object({
      remoteSessionIssuerId: z.string(),
      cursor: z.optional(z.string()),
      limit: z.optional(z.int()),
      gramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        remoteSessionIssuerId: "remote_session_issuer_id",
        gramSession: "Gram-Session",
      });
    }),
  );

export function listGlobalRemoteSessionClientsRequestToJSON(
  listGlobalRemoteSessionClientsRequest: ListGlobalRemoteSessionClientsRequest,
): string {
  return JSON.stringify(
    ListGlobalRemoteSessionClientsRequest$outboundSchema.parse(
      listGlobalRemoteSessionClientsRequest,
    ),
  );
}

/** @internal */
export const ListGlobalRemoteSessionClientsResponse$inboundSchema:
  z.ZodMiniType<ListGlobalRemoteSessionClientsResponse, unknown> = z.pipe(
    z.object({
      Result: ListRemoteSessionClientsResult$inboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        "Result": "result",
      });
    }),
  );

export function listGlobalRemoteSessionClientsResponseFromJSON(
  jsonString: string,
): SafeParseResult<ListGlobalRemoteSessionClientsResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      ListGlobalRemoteSessionClientsResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListGlobalRemoteSessionClientsResponse' from JSON`,
  );
}
